import script from "./tablist.vue?vue&type=script&setup=true&lang=js"
export * from "./tablist.vue?vue&type=script&setup=true&lang=js"

import "./tablist.vue?vue&type=style&index=0&id=9814cf98&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9814cf98"]])

export default __exports__